import React from 'react';
import { ellipsize } from '../../utils/textUtil';
import { Box, Typography, makeStyles } from '@material-ui/core';
import imgParams from '../../utils/imageUtil';
import { useMobile } from '../../hooks/utilHooks';
import Carousel from 'react-multi-carousel';
import { ReactComponent as PlayIcon } from '../../img/play.svg';
import { ReactComponent as LockIcon } from '../../img/lock-icon.svg';
import { useSnackBar } from '../../hooks/snackBarHooks';
import useReactRouter from 'use-react-router';

const ChapterCarousel = ({ post, cards }) => {
  const classes = useStyles();
  const isMobile = useMobile();
  const snackBar = useSnackBar();
  const { history } = useReactRouter();

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1.2,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1.2,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1.2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1.2,
    },
  };

  const handleClickItem = (cardId) => {
    history.push('/lecture/' + btoa(cardId));
  };

  return (
    <React.Fragment>
      <Box
        height={isMobile ? '270px' : '270px'}
        bgcolor="#f5f5f5"
        px={isMobile ? 2 : 0}
      >
        <Box py={1}>
          <Typography variant="body2">{post.title}</Typography>
        </Box>
        <Carousel
          responsive={responsive}
          removeArrowOnDeviceType={['tablet', 'mobile']}
          showDots={true}
          className="feedChapterCarousel"
        >
          {cards &&
            cards.map((card, index) => (
              <div
                className={classes.carouselItem}
                onClick={() =>
                  card.lockedMessage
                    ? snackBar(card.lockedMessage)
                    : handleClickItem(card.cardId)
                }
                key={index}
              >
                {card.name && (
                  <Box display="flex" alignItems="center" px={2}>
                    <Typography variant="body1" className={classes.videoDes}>
                      {ellipsize(card.name, isMobile ? 30 : 50)}
                    </Typography>
                  </Box>
                )}
                <Box
                  position="relative"
                  className={classes.defaultImg}
                  height={isMobile ? '170px' : '208px'}
                >
                  <img
                    src={imgParams(card.imageUrl, 480, 240, 'auto')}
                    width="100%"
                    alt="Video Thumbnail"
                    className={classes.videoImg}
                    height="100%"
                  />
                  {card.isVideoLocked ? (
                    <LockIcon className="lockGreyIcon2" />
                  ) : (
                    <PlayIcon className="videoGreyIcon2" />
                  )}
                </Box>
              </div>
            ))}
        </Carousel>
      </Box>
    </React.Fragment>
  );
};

const useStyles = makeStyles((theme) => ({
  defaultImg: {
    background: theme.palette.grey[100],
    boxShadow: 'rgb(0 0 0 / 24%) 0px 3px 8px',
    borderRadius: theme.spacing(2.5),
    '&::before': {
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      content: `''`,
      position: 'absolute',
      left: theme.spacing(0),
      right: theme.spacing(0),
      width: 'auto',
      height: '100%',
    },
  },
  carouselItem: {
    margin: theme.spacing(0, 3, 0, 0),
    borderRadius: theme.spacing(2.5),
  },
  videoImg: {
    borderRadius: theme.spacing(2.5),
  },
  videoDes: {
    color: '#3c3c3c',
    margin: theme.spacing(2, 0),
  },
  dotIcon: {
    color: '#747171',
    margin: theme.spacing(0, 1, 0, 0),
    fontSize: '6px',
  },
  mainCarousel: {
    margin: '0',
  },
}));
export default ChapterCarousel;
